<ri-resolution-ui-lazy-load-container
  [hasMoreItems]="hasGroupsToFetch()"
  (loadMoreItems)="loadTaskGroups()"
>
  <ri-resolution-ui-sidebar-flat-tasks-list
    [tasks]="flatTasksList()"
  ></ri-resolution-ui-sidebar-flat-tasks-list>

  <ng-template #message>
    <div class="p-3 text-center text-sm text-gray-500">
      @if (isLoading()) {
        Loading...
      } @else if (hasTasksLessThanLimit() && !hasGroupsToFetch()) {
        No additional tasks
      } @else if (hasNoTasks()) {
        No Tasks
      } @else if (!hasGroupsToFetch()) {
        No more tasks to load
      }
    </div>
  </ng-template>
</ri-resolution-ui-lazy-load-container>
